module.exports = __webpack_public_path__ + "img/artichokes.c48d46c8.png";